export default __webpack_public_path__ + "static/media/avatar_1@2x.be1ba28b.png";